import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import axios from 'axios';
import QS from 'qs';
import { getToken, removeToken } from '@/utils/storage'; // const isPrd = process.env.NODE_ENV == 'production';
// export const basicUrl = isPrd ? 'https://www.production.com' : 'http://www.development.com'

const errCodes = {
  1100: '消息格式错误',
  1101: '请求方法错误',
  1200: '验证码验证失败',
  1210: '验证码提交过于频繁',
  1300: '资源访问被拒绝',
  1310: '资源操作被拒绝',
  1400: '注册失败',
  1410: 'Account is used',
  1420: '账号格式不合法',
  1500: '账号密码不匹配',
  1510: 'Invalid email',
  1520: 'Invalid password',
  1530: 'User is locked',
  1600: 'Reset password is failed',
  1610: '重置密码过于频繁',
  2000: '登录会话过期',
  5000: '内部错误',
  5100: '服务器繁忙',
  5300: '服务更新中'
};
const service = axios.create({
  timeout: 1000 * 12
}); // 请求拦截器

service.interceptors.request.use(config => {
  const token = getToken();
  config.headers = {
    Token: token,
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
  };
  config.data = QS.stringify(config.data);
  return config;
}, error => {
  return error;
}); // 响应拦截器
// 根据业务状态码
// TODO: 双Token

service.interceptors.response.use(response => {
  console.log('interceptor success');

  if (response.data.code > 1000) {
    removeToken(); // 优先展示后端返回的业务提示(如「账号已被锁定, 请联系管理员」), 没有再退回错误码表

    _Message.error(response.data.message || errCodes[response.data.code]);

    if (response.data.code === 2000) {
      window.location.href = '/login';
    }
  } else {
    return response;
  }
}, error => {
  switch (error.response.status) {
    case 403:
      _Message.error('no permission');

      break;

    case 404:
      _Message.error('API not found');

      break;

    case 503:
      _Message.error('Server intenal error');

      break;
  }

  return Promise.reject(error);
});
export default service;